import { Checkbox } from '@eigtech/ui/components/checkbox'
import { FieldValues, useController } from 'react-hook-form'
import { WithFieldNameAndDefaultValueProps } from '../types/FieldProps'
import { BaseProps, FieldControl } from './FieldControl'
import { Label } from '@eigtech/ui/components/label'

export type CheckboxFieldProps<TFieldValues extends FieldValues = FieldValues> =
  WithFieldNameAndDefaultValueProps<BaseProps<TFieldValues>, TFieldValues> & {
    checkboxProps?: React.ComponentProps<typeof Checkbox>
  }

export function CheckboxField<TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  label,
  children,
  checkboxProps,
  defaultValue,
  ...props
}: CheckboxFieldProps<TFieldValues>) {
  const {
    field,
    formState: { isSubmitting },
  } = useController({
    name,
    control,
    defaultValue,
  })

  const isChecked = field.value

  const checkbox = (
    <Checkbox
      {...field}
      checked={isChecked}
      disabled={isSubmitting}
      id={name}
      onCheckedChange={field.onChange}
      {...checkboxProps}
    />
  )

  return (
    <FieldControl control={control} name={name} {...props}>
      {label || children ? (
        <Label className="flex items-center gap-2">
          {checkbox}
          {label}
          {children}
        </Label>
      ) : (
        checkbox
      )}
    </FieldControl>
  )
}

export type CheckboxFieldComponent<TFieldValues extends FieldValues = FieldValues> =
  typeof CheckboxField<TFieldValues>
